import { Route, Routes } from "react-router-dom";
import PrivateRoutes from "../../core/routes/PrivateRoutes";
import { Layout } from "../../core/components/Layout";
import { AdminOrganizacoes } from "../pages/AdminOrganizacoes";

interface IAdminOrganizacoesRoutesProps {
    autenticado: boolean;
}

export const AdminOrganizacoesRoutes = ({ autenticado }: IAdminOrganizacoesRoutesProps) => {
    return (
        <Routes>
            <Route element={
                <Layout titulo="Organizações">
                    <PrivateRoutes autenticado={autenticado} />
                </Layout>
            }>
                <Route path="/organizacoes" index element={<AdminOrganizacoes />} />
            </Route>
        </Routes>
    );
};
